module.exports = __webpack_public_path__ + "static/media/wally-head.c8a752e7.svg";